import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_INVOICES}`;

const request = async (method, endpoint, data = null, params = null) => {
  const url = `${BASE_URL}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};

// 🔹 Funciones para impuestos (taxes)
export const taxes_get = () => request("get", "/od/taxes");
export const taxes_post = (data) => request("post", "/od/taxes", data);
export const taxes_delete = (id) => request("delete", `/od/taxes/${id}`);

// 🔹 Configuración de impuestos
export const taxes_config_get = (id) => request("get", `/od/taxes/${id}/config`);
export const taxes_config_post = (id, data) => request("post", `/od/taxes/${id}/config`, data);
export const taxes_config_put = (id, idi) => request("put", `/od/taxes/${id}/config/${idi}`);
export const taxes_config_delete = (id, idi) => request("delete", `/od/taxes/${id}/config/${idi}`);
